import { useStrapiApi } from "~/uses/useMyFetch";
import { getHeaderBannerQuery } from "~/utils/strapiQuery.utils";

export const useHeaderStore = defineStore({
  id: "headerStore",
  state: () => {
    return {
      modalMenu: {
        active: false,
      },
      modalCatalog: {
        active: false,
      },
      height: {
        header: 0,
        additionalInfo: 0,
      },
      headerBanner: null,
    };
  },
  actions: {
    activeModal(state) {
      this.modalMenu.active = state;

      state
        ? (document.body.style.overflow = "hidden")
        : (document.body.style.overflow = "auto");
    },
    activeCatalog(state) {
      this.modalCatalog.active = state;
    },
    setHeightHeader(height) {
      this.height.header = height;
    },
    setAdditionalInfo(height) {
      this.height.additionalInfo = height;
    },
    async fetchHeaderBanner() {
      await useStrapiApi(`/banners/header?${getHeaderBannerQuery()}`).then(
        ({ data }) => {
          this.headerBanner = data;
        },
      );
    },
  },
  getters: {
    getModalMenu: (state) => state.modalMenu,
    getModalCatalog: (state) => state.modalCatalog,
    getHeightHeader: (state) => state.height,
  },
});
